import { Typography, Tooltip } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { FC } from "react";
import { Link } from "react-router-dom";
import { setBackEndUlr } from "helpers/SetBackEndUrl";

const NewsListItem: FC<any> = ({ item }) => {
  const { Text } = Typography;
  console.log(item)
  return (
    <div className="!rounded-lg">
      <div className="!rounded-lg !w-full !h-[200px] md:!h-[250px] !overflow-hidden">
        <Link to={`/haber/detay/${item.id}`}>
          <LazyLoadImage
            src={
              item.media.length > 0
                ? setBackEndUlr() + "/" + item.media[0].fullPath
                : ""
            }
            style={{ height: "auto" }}
            alt="News"
            wrapperWidth="100%"
            wrapperHeight="100%"
            classNames="!h-[200px] md:!h-[auto]"
            imageClassName="!object-contain"
            preview={false}
          />
        </Link>
      </div>

      <div className="!grid gap-3 !pt-4">
        <div>
          <Link to={`/haber/detay/${item.id}`}>
            {item.title.length <= 40 ? (
              <Text className="!font-bold !text-base">{item.title}</Text>
            ) : (
              <Tooltip title={item.title}>
                <Text className="!font-bold !text-base">
                  {item.title.slice(0, 40)}
                </Text>
              </Tooltip>
            )}
          </Link>
        </div>
        <div className="!h-[100px] !overflow-hidden">
          <Text className="!text-xs !text-[#98a0a8]">
            {item.shortDescription.length <= 140
              ? item.shortDescription
              : item.shortDescription.slice(0, 140) + "..."}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default NewsListItem;
